import React from "react";
import { classNames } from "~/utils";

export default function Blockquote({
  text,
  variant,
}: {
  text: string;
  variant: "default" | "note" | "comment" | "ai";
}) {
  return (
    <blockquote
      className={classNames(
        "border-l-4 pl-6 line-clamp-6",
        variant === "note" ? "bg-note border-note-hover bg-note/40" : "",
        variant === "comment"
          ? "bg-comment border-comment-hover dark:bg-comment/50"
          : "",
        variant === "default"
          ? "bg-note border-muted italic dark:bg-note/40"
          : "",
        variant === "ai" ? "bg-ai border-ai-hover dark:bg-ai/50" : "",
      )}
    >
      "{text.trim()}"
    </blockquote>
  );
}

export function HighlightBlockquote({
  text,
  model,
}: {
  text: string;
  model?: string;
}) {
  if (model === "marker0") {
    return <Blockquote text={text} variant={"note"} />;
  }
  if (model === "marker1") {
    return <Blockquote text={text} variant={"comment"} />;
  }
  if (model === "marker2") {
    return <Blockquote text={text} variant={"ai"} />;
  }
  return <Blockquote text={text} variant={"note"} />;
}
